export function formatDate(rawDate, locale = 'en-US', options = {}) {
    if (!rawDate) return '';

    // Ensure "+0000" is parsed correctly
    const isoDate = rawDate.replace('+0000', 'Z');

    try {
        const date = new Date(isoDate);

        const defaultOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        return date.toLocaleString(locale, { ...defaultOptions, ...options });
    } catch (e) {
        console.warn("Invalid date format:", rawDate);
        return rawDate;
    }
}

// Check session expiration
export function checkSession() {
    console.log('called checkSession');
    // const axios = require('axios');
    // const url = `https://api.myaccount.tinkerpub.com/v1/user`;

    // if (!localStorage.getItem('web_session_id')) {
    //     return;
    // }

    // console.log('get user', localStorage.getItem('web_session_id'));

    // const payload = {
    //     // your request body here
    // };

    // const headers = {
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    // };

    // headers['X-SESSION-ID'] = localStorage.getItem('web_session_id');

    // try {
    //     const response = axios.post(url, payload, {
    //         headers: headers
    //     });

    //     const session_details = response.data;

    //     console.log("Current session token:", session_details);
    // } catch (error) {
    //     console.error("Error checking session token:", error.response?.data || error.message);
    // }
}

// Logout function
export function logout() {
    localStorage.removeItem('session_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('token');
    window.location.href = '/login';
}